<template>
  <div>

    <v-card class="ma-2" v-if="!display">
      <v-card-text>
        <div class="text-center headline">Anda harus input data PERUSAHAAN terlebih dulu !</div>
      </v-card-text>
    </v-card>

    <v-card class="ma-2" v-if="display">
      <v-card-title  class="teal white--text">
        Pengalaman Perusahaan (minimal 2)
        <v-spacer />
        <v-btn  @click.stop="openForm(null)">
          <v-icon left>add</v-icon>
          Tambah
        </v-btn>
      </v-card-title>

      <v-data-table
          class="elevation-1"
          :headers="headers"
          :items="pos6List"
          :items-per-page="10"
          :single-select="true"
          item-key="id"
      >
        <template v-slot:item.instansi_pemberi="{item}">
          <v-btn icon color="grey" @click.prevent="getLinkDownload(item.dokumen)"><v-icon>get_app</v-icon></v-btn>
          {{ item.instansi }}
        </template>
        <template v-slot:item.tglMulai="{item}">
          {{ getDatefnsFormat(item.tglPelaksanaan) }}
        </template>
        <template v-slot:item.tglSelesai="{item}">
          {{ getDatefnsFormat(item.tglSelesaiKontrak) }}
        </template>
        <template v-slot:item.actions="{item}">
          <v-btn icon color="cyan" @click="openForm(item)"> <v-icon>mdi-pencil</v-icon> </v-btn>
          <v-btn icon color="pink" @click="deletePengalaman(item.id)"><v-icon>delete</v-icon></v-btn>
        </template>
      </v-data-table>

    </v-card>

    <v-dialog v-model="dlgPengalaman" persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Tambah Pengalaman Pekerjaan</span>
        </v-card-title>
        <v-card-text>
          <v-form
            ref="form6"
            v-model="valid"
            lazy-validation
          >
            <v-container>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    label="Nama Kontrak / Pekerjaan"
                    type="text"
                    outlined
                    v-model="pengNamaKontrak"
                    :rules="[rules.required]"
                  />  
                  <v-text-field
                    label="Lokasi Pekerjaan"
                    type="text"
                    outlined
                    v-model="pengLokasi"
                    :rules="[rules.required]"
                  />  
                  <v-text-field
                    label="Instansi Pemberi Pekerjaan"
                    type="text"
                    outlined
                    v-model="pengInstansi"
                    :rules="[rules.required]"
                  />  
                  <v-text-field
                    label="Alamat"
                    type="text"
                    outlined
                    v-model="pengAlamat"
                    :rules="[rules.required]"
                  />  
                  <v-text-field
                    label="Telepon"
                    type="text"
                    outlined
                    v-model="pengTelepon"
                    :rules="[rules.required]"
                  />  
                  <v-text-field
                    label="Keterangan"
                    type="text"
                    outlined
                    v-model="pengKeterangan"
                    :rules="[rules.required]"
                  />  
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    label="Nomor Kontrak"
                    type="text"
                    outlined
                    v-model="pengNoKontrak"
                    :rules="[rules.required]"
                  />  
                  <text-field-rupiah
                    label="Nilai Kontrak"
                    v-model="pengNilaiKontrak"
                    outlined
                    :rules="[rules.required]"
                  />  
                  <v-menu
                    v-model="menuTglPelaksanaan"
                    :close-on-content-click="false"
                    max-width="290"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="getDateFormattedDatefns(pengTglPelaksanaan)"
                        clearable
                        label="Tanggal Pelaksanaan"
                        readonly
                        v-on="on"
                        outlined
                        :rules="[rules.required, validateTanggalKontrak()]"
                        @click:clear="pengTglPelaksanaan = null"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="pengTglPelaksanaan"
                      @change="menuTglPelaksanaan = false"
                    ></v-date-picker>
                  </v-menu>
                  <v-text-field
                    label="Persentase Pelaksanaan"
                    type="number"
                    suffix="%"
                    outlined
                    v-model="pengPersentase"
                    :rules="[rules.required]"
                  />  
                  <v-menu
                    v-model="menuTglSelesaiKontrak"
                    :close-on-content-click="false"
                    max-width="290"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="getDateFormattedDatefns(pengTglSelesaiKontrak)"
                        clearable
                        label="Tanggal Selesai Kontrak"
                        readonly
                        v-on="on"
                        outlined
                        :rules="[rules.required, validateTanggalKontrak()]"
                        @click:clear="pengTglSelesaiKontrak = null"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="pengTglSelesaiKontrak"
                      @change="menuTglSelesaiKontrak = false"
                    ></v-date-picker>
                  </v-menu>
                  <v-menu
                    v-model="menuTglSerahTerima"
                    :close-on-content-click="false"
                    max-width="290"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="getDateFormattedDatefns(pengTglSerahTerima)"
                        clearable
                        label="Tanggal Serah Terima"
                        readonly
                        v-on="on"
                        outlined
                        :rules="[validateTanggalSerahTerima()]"
                        @click:clear="pengTglSerahTerima = null"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="pengTglSerahTerima"
                      @change="menuTglSerahTerima = false"
                    ></v-date-picker>
                  </v-menu>                  
                </v-col>                
              </v-row> 
              <v-row>
                <v-file-input 
                    outlined 
                    accept=".jpg,.png,.pdf"
                    label="Surat Keterangan Instansi"
                    v-model="uploadFileDokumen"
                    chips
                    :rules="[checkFileDokumen()]"
                    :placeholder="pengDokumen"
                    append-icon="get_app"
                    @click:append="getLinkDownload(pengDokumen)" 
                  ></v-file-input>
              </v-row>             
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" dark @click="dlgPengalamanSimpanClick">Simpan</v-btn>
          <v-btn color="orange" dark @click="closeForm()">Batal</v-btn>
          <v-btn color="info" dark @click="resetForm6">Reset</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="submitting" persistent max-width="300px">
        <v-card dark>
            <v-card-title>Sedang diproses</v-card-title>
            <v-card-text> <v-progress-linear color="cyan" indeterminate /> </v-card-text>
        </v-card>
    </v-dialog>
    <v-dialog v-model="loginExpired" max-width="400" persistent>
        <v-card>
            <v-card-title>Login Expired</v-card-title>
                <v-card-text>Silakan Login Ulang</v-card-text>
            <v-card-actions>
                <v-btn color="red" @click="logoutClick()">Ya</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { format, parseISO } from 'date-fns'
import { rules as Rules } from "./../../lib/rules";
import TextFieldRupiah from "./../../components/TextFieldRupiah.vue";
const apiUrl = process.env.VUE_APP_ROOT_API

export default {
  components: {
    "text-field-rupiah": TextFieldRupiah
  },

  data: function() {
    return {
      valid: true,
      // data pengalaman
      dlgPengalaman: false,
      pos6Count: 0,
      pos6List: [],
      exPengalaman: [
        {
          id: 199,
          namaKontrak: 'Pengadaan aplikasi Kepegawaian',
          lokasi: 'Jakarta Pusat',
          instansi: 'Dinas Pendidikan DKI Jakarta',
          alamat: 'Jl Sudirman no 1 Jakarta',
          tglPelaksanaan: '2017-03-20',
          tglSelesaiKontrak: '2017-09-19'
        },
        {
          id: 299,
          namaKontrak: 'Pengadaan AC Gedung Pertemuan',
          lokasi: 'Jakarta Selatan',
          instansi: 'Dinas Sumberdaya Air DKI Jakarta',
          alamat: 'Gedung Juang Merdeka jl Angkasa no 1 Jakarta',
          tglPelaksanaan: '2019-06-01',
          tglSelesaiKontrak: '2019-06-10'
        }
      ],
      pengNamaKontrak: '',
      pengLokasi: '',
      pengInstansi: '',
      pengAlamat: '',
      pengTelepon: '',
      pengNoKontrak: '',
      pengNilaiKontrak: 0,
      pengTglPelaksanaan: "",
      menuTglPelaksanaan: false,
      pengTglSelesaiKontrak: "",
      menuTglSelesaiKontrak: false,
      pengPersentase: 0,
      menuTglSerahTerima: false,
      pengTglSerahTerima: null,
      pengKeterangan: '',
      pengDokumen: '',
      isEditing: false,
      editId: null,
      uploadFileDokumen: null,
      dlgEverOpened: false,
      rules: {
          required: Rules.required,
      },

      // Table headers
      headers: [
        { text: "Nama Kontrak / Pekerjaan", value: "namaKontrak", class: "green accent-2 subtitle-2" },
        { text: "Lokasi Pekerjaan", value: "lokasi", class: "green accent-2 subtitle-2" },
        { text: "Instansi Pemberi", value: "instansi_pemberi", class: "green accent-2 subtitle-2" },
        { text: "Alamat", value: "alamat", class: "green accent-2 subtitle-2" },
        { text: "Tgl Mulai", value: "tglMulai", class: "green accent-2 subtitle-2" },
        { text: "Tgl Selesai", value: "tglSelesai", class: "green accent-2 subtitle-2" },
        { text: "", value: "actions", sortable: false,  class: "green accent-2 subtitle-2" },
      ],

      submitting: false,
      loginExpired: false
    }
  },
  computed: {
    display: function() {
      return this.$store.getters['ven/venId'] != -999
    },
    venId: function() { 
      return this.$store.getters['ven/venId']
    },
  },
  methods: {
    validateTanggalKontrak: function() {
      const startDate = new Date(this.pengTglPelaksanaan);
      const endDate = new Date(this.pengTglSelesaiKontrak);
      return startDate < endDate || "Tanggal pelaksanaan harus mendahului tanggal selesai";
    },
    validateTanggalSerahTerima: function() {
      const startDate = new Date(this.pengTglSelesaiKontrak);
      const endDate = new Date(this.pengTglSerahTerima);
      return startDate < endDate || "Tanggal selesai kontrak harus mendahului tanggal serah terima";
    },
    checkFileDokumen: function() {
      if (this.isEditing && this.pengDokumen != "") return true;
      return this.uploadFileDokumen != null || `Hasil melampirkan surat keterangan dari instansi pemberi kerja`;
    },
    resetForm: function() {
      this.pengTglPelaksanaan = "";
      this.pengTglSelesaiKontrak = "";
      this.pengTglSerahTerima = "";
      this.pengNilaiKontrak = 0;

      if (this.dlgEverOpened) {
        this.$refs.form6.reset();
      }
    },
    closeForm: function() {
      this.resetForm();

      this.dlgPengalaman = false;
      this.isEditing = false;
    },

    openForm: function(pengalaman) {
      this.resetForm();

      if (pengalaman) {
        console.log("Edit: ", pengalaman);
        this.pengNamaKontrak = pengalaman.namaKontrak;
        this.pengLokasi = pengalaman.lokasi;
        this.pengInstansi = pengalaman.instansi;
        this.pengAlamat = pengalaman.alamat;
        this.pengTelepon = pengalaman.telepon;
        this.pengNoKontrak = pengalaman.noKontrak;
        this.pengNilaiKontrak = Number(pengalaman.nilaiKontrak);
        this.pengTglPelaksanaan = pengalaman.tglPelaksanaan;
        this.pengTglSelesaiKontrak = pengalaman.tglSelesaiKontrak;
        this.pengPersentase = pengalaman.persentase;
        this.pengTglSerahTerima = pengalaman.tglSerahTerima;
        this.pengKeterangan = pengalaman.keterangan;
        this.pengDokumen = pengalaman.dokumen;
        this.isEditing = true;
        this.editId = pengalaman.id;
      }
      
      this.dlgPengalaman = true;
      this.dlgEverOpened = true;
    },
    
    dlgPengalamanSimpanClick: async function() {
      if (!this.$refs.form6.validate()) return;

      // create message untuk simpan ke database
      const newPengalaman = {
        id: null,
        namaKontrak: this.pengNamaKontrak,
        lokasi: this.pengLokasi,
        instansi: this.pengInstansi,
        alamat: this.pengAlamat,
        telepon: this.pengTelepon,
        noKontrak: this.pengNoKontrak,
        nilaiKontrak: this.pengNilaiKontrak,
        persentase: this.pengPersentase,
        tglPelaksanaan: this.pengTglPelaksanaan,
        tglSelesaiKontrak: this.pengTglSelesaiKontrak,
        tglSerahTerima: this.pengTglSerahTerima,
        keterangan: this.pengKeterangan,
        vendorId: this.venId,
        dokumen: ''
      }
     
      let fData = new FormData();
      fData.append("namaKontrak", this.pengNamaKontrak);
      fData.append("lokasi", this.pengLokasi);
      fData.append("instansi", this.pengInstansi);
      fData.append("alamat", this.pengAlamat);
      fData.append("telepon", this.pengTelepon);
      fData.append("noKontrak", this.pengNoKontrak);
      fData.append("nilaiKontrak", this.pengNilaiKontrak);
      fData.append("persentase", this.pengPersentase);
      fData.append("tglPelaksanaan", this.pengTglPelaksanaan);
      fData.append("tglSelesaiKontrak", this.pengTglSelesaiKontrak);
      fData.append("tglSerahTerima", this.pengTglSerahTerima);
      fData.append("keterangan", this.pengKeterangan);
      fData.append("vendorId", this.venId);
      if (this.uploadFileDokumen) fData.append("dokumen", this.uploadFileDokumen);

      this.$store.dispatch('displayProgBar')  

      if (this.isEditing) {
        this.submitting = true;

        await axios.put(apiUrl + '/vendor/register3/pengalaman/' + this.editId, fData, { headers: { 'Content-Type': 'multipart/form-data' }})
        .then((response) => {
          this.$store.dispatch('displayAlert', {
            color: 'success', 
            message: `Data pengalaman telah diperbarui !` 
          });

          //this.$store.dispatch('ven/assignVendor', response.data.data)
          //this.$store.commit('reg/setStatusPengalaman', 'V')
          window.scroll(0,0)

          const index = this.pos6List.findIndex(element => { return element.id === this.editId; });
          if (index != -1) {
            this.pos6List.splice(index, 1, response.data);
          }
        })
        .catch((error) => {
          if(error.response.status == 401) {
            this.loginExpired = true;
          }else if(error.response.status == 422) {
            this.loginExpired = true;
          }else {
            this.$store.dispatch('displayAlert', {color: 'error', message: `Gagal menyimpan! ${error.response.data.message}`})
            window.scroll(0,0)
          }
        })
        .finally(() => {
          this.$store.dispatch('closeProgBar');
          this.submitting = false;
        })    
      }
      else {
        // simpan ke database
        this.submitting = true;

        await axios.post(apiUrl + '/vendor/register3/pengalaman', fData, { headers: { 'Content-Type': 'multipart/form-data' }})
        .then((response) => {
          this.$store.dispatch('displayAlert', {
            color: 'success', 
            message: `Data pengalaman telah tersimpan !` })
          this.$store.dispatch('ven/assignVendor', response.data.data)
          window.scroll(0,0)
          
          // proses response
          newPengalaman.id = response.data.data.pengalamanId;
          newPengalaman.dokumen = response.data.data.dokumen;
          this.pos6List.push(newPengalaman)
          this.pos6Count = this.pos6List.length;

          if (this.pos6Count >= 2 && this.$store.getters['reg/statusPengalaman'] != 'A') {
            this.$store.commit('reg/setStatusPengalaman', 'V')
          }

        })
        .catch((error) => {
          if(error.response.status == 401) {
            this.loginExpired = true;
          }else if(error.response.status == 422) {
            this.loginExpired = true;
          }else {
            this.$store.dispatch('displayAlert', {color: 'error', message: `Gagal menyimpan! ${error.response.data.message}`})
            window.scroll(0,0)
          }
        })
        .finally(() => {
          this.$store.dispatch('closeProgBar');
          this.submitting = false;
        })    
      }

      this.closeForm();

    },
    deletePengalaman: async function(id) {
      // hapus database
      this.submitting = true;

      await axios.delete(apiUrl+`/vendor/pengalaman/${id}`)
      .then((response) => {
        if (response.data.statusCode != 200) { // hapus gagal
          this.alertMsg = `Error dalam penghapusan data ! Silahkan coba beberapa saat lagi - ${response.data.message}`
          this.alertColor = "error"
          this.alert = true
        }
        else { // hapus berhasil
          // hapus element data table
          this.pos6List = this.pos6List.filter(function(el) {
            return el.id !== id;
          });
          this.pos6Count = this.pos6List.length;

        }
      })
      .catch((error) => {
        this.alertMsg = `Error dalam penghapusan data ! Silahkan coba beberapa saat lagi - ${error}`
        this.alertColor = "error"
        this.alert = true
      })  
      .finally( () => {
        this.submitting = false;
      })
    },
    resetForm6: function() {
      this.$refs.form6.reset()
      this.isEditing = false;
      this.editId = null;
      this.uploadFileDokumen = null;
    },
    getLinkDownload: function(dok) {
      axios.get(`${apiUrl}/${dok}`, { responseType: 'blob' })
      .then(response => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = dok
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(console.error)
    },
    getDatefnsFormat: function(date) {
      return format(parseISO(date), "dd MMM yyyy")
    },
    getDateFormattedDatefns: function(date) {
      return date ? format(parseISO(date), "dd MMM yyyy") : ''
    },
    logoutClick: function() {
        this.$store.dispatch('logout')
        .then(() => {
            this.$router.push('/')
        })
    }
  },
  created: async function() {
    this.$store.dispatch('displayPageTitle', 'Pengalaman Perusahaan')
    await axios.get(apiUrl+'/vendor/pengalaman/'+this.venId)
    .then((response) => {
      if (response.data.statusCode != 200) {
        this.pos6List = []
      }
      else {
        response.data.data.forEach(element => {
          this.pos6List.push(element)
        })              
      }
      this.pos6Count = this.pos6List.length
    })
    .catch((error) => {
      console.log(error)
    })  
  }
}
</script>

<style>

</style>